import styled from 'styled-components';

import { zIndexMap } from '../shared/config';
import { BaseButton, PrimaryButton, rubikTypographyStyles } from '../shared/ui';

export const LogoutConfirmBackdrop = styled.div.attrs({
  'data-ui': 'account-logout-confirm-overlay',
})<{ $isOpen: boolean }>`
  position: absolute;
  inset: 0;
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  padding-right: ${({ theme }) =>
    `max(${theme.scale.px(28)}, env(safe-area-inset-right))`};
  padding-left: ${({ theme }) =>
    `max(${theme.scale.px(28)}, env(safe-area-inset-left))`};
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.surface.backdrop};
  z-index: ${zIndexMap.myPageSettings.logoutConfirmOverlay};
`;

export const LogoutConfirmCard = styled.section`
  width: min(100%, ${({ theme }) => theme.scale.px(331)});
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.scale.px(18)};
  background: ${({ theme }) => theme.colors.surface.base};
  padding: ${({ theme }) => theme.scale.px(24)};
  display: grid;
  gap: ${({ theme }) => theme.scale.px(16)};
`;

export const LogoutConfirmTitle = styled.h2`
  ${rubikTypographyStyles};
  margin: 0;
  font-size: ${({ theme }) => theme.scale.px(24)};
  font-weight: 600;
  line-height: ${({ theme }) => theme.scale.px(28)};
`;

export const LogoutConfirmDescription = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.scale.px(12)};
  font-weight: 500;
  line-height: ${({ theme }) => theme.scale.px(15)};
`;

export const LogoutConfirmActions = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.scale.px(10)};
`;

export const LogoutConfirmCancelButton = styled(BaseButton)`
  ${rubikTypographyStyles};
  width: 100%;
  min-height: ${({ theme }) => theme.scale.px(56)};
  border-radius: ${({ theme }) => theme.scale.px(10)};
  border: ${({ theme }) => theme.scale.px(2)} solid
    ${({ theme }) => theme.colors.support.infoSubtle};
  color: ${({ theme }) => theme.colors.text.subdued};
  font-size: ${({ theme }) => theme.scale.px(15)};
  font-weight: 600;
  line-height: 1.25;
`;

export const LogoutConfirmSubmitButton = styled(PrimaryButton)`
  width: 100%;
`;
